import React, { FC } from 'react';

import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';
import { Flex } from '@adsk/alloy-react-box';
import Illustration from '@adsk/alloy-react-illustration';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import { StylableComponent } from '@adsk/alloy-react-theme';

type TopBarProps = StylableComponent<HTMLDivElement> & {
  hideLogo?: boolean;
  admin?: boolean;
};

const TopBar: FC<TopBarProps> = ({
  className,
  style,
  children,
  hideLogo,
  admin,
}) => {
  const accLogo = (
    <Illustration
      style={{ ...(hideLogo && { visibility: 'hidden' }) }}
      type={Illustration.TYPES.ACC_HORIZONTAL_WHITE_NEW_2022}
    />
  );

  return (
    <Flex
      className={className}
      data-testid="TopNavigation__TopBar"
      alignItems="center"
      padding="2px 10px"
      height="24px"
      bg={admin ? 'charcoal700' : 'black'}
      style={style}
    >
      {!hideLogo && (
        <a data-testid="TopNavigation__TopBar__a" href={getAccOrigin()}>
          {accLogo}
        </a>
      )}
      {children}
    </Flex>
  );
};

TopBar.displayName = 'TopBar';

export default WithAlloySuspense(TopBar);
